import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=c0cfb902&"
import script from "./Verify.vue?vue&type=script&lang=ts&"
export * from "./Verify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports